import {Injectable} from '@angular/core';
import {BehaviorSubject, EMPTY, interval, switchMap} from "rxjs";
import {environment} from "@environment";

export const TOAST_STATE: { success: string; warning: string; danger: string } = {
  success: 'success-toast',
  warning: 'warning-toast',
  danger: 'danger-toast'
};

@Injectable({ providedIn:'root' })
export class ToastService {
  public showsToast$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public toastMessage$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public toastState$: BehaviorSubject<string> = new BehaviorSubject<string>(TOAST_STATE.success);

  constructor() {
    this.showsToast$.pipe(
      switchMap((value: boolean) => value ? interval(environment.toastDurationTime) : EMPTY)
    ).subscribe(() => this.dismissToast());
  }

  showToast(toastState: string, toastMsg: string): void {
    // This updates the toastMessage to the toastMsg passed into the function
    this.toastMessage$.next(toastMsg);

    // Observables use '.next()' to indicate what they want done with observable
    // This will update the toastState to the toastState passed into the function
    this.toastState$.next(toastState);

    // This will update the showsToast trigger to 'true'
    this.showsToast$.next(true);
  }

  // This updates the showsToast behaviourSubject to 'false'
  dismissToast(): void {
    this.showsToast$.next(false);
  }
}
